import { Modal } from '@/components/ui/Modal'
import { CustomCardForm, EMPTY_CARD_VALUES } from './CustomCardForm'
import type { CustomCardValues } from './CustomCardForm'
import { useCreateCustomFlashcard } from '@/hooks/useCreateCustomFlashcard'

interface AddCustomCardModalProps {
  languageId: number
  initial?: Partial<CustomCardValues>
  trackedForm?: string
  open: boolean
  onClose: () => void
  onCreated: () => void
}

/** Standalone "create a custom card" modal — used from the reading popover. */
export function AddCustomCardModal({
  languageId, initial, trackedForm, open, onClose, onCreated,
}: AddCustomCardModalProps) {
  const { create, submitting, errors } = useCreateCustomFlashcard(() => {
    onCreated()
    onClose()
  })

  function handleSubmit(values: CustomCardValues) {
    create({
      language_id: languageId,
      lemma: values.lemma,
      translation: values.translation,
      part_of_speech: values.part_of_speech || null,
      gender: values.gender || null,
      example_sentence: values.example_sentence || null,
      notes: values.notes || null,
      tracked_forms: trackedForm ? [trackedForm] : undefined,
    })
  }

  if (!open) return null

  return (
    <Modal open onClose={onClose} title="Add custom card">
      <p className="text-sm text-muted font-light leading-relaxed mb-4">
        This card stays private to you and joins your reviews like any tracked word.
      </p>
      <CustomCardForm
        initial={{ ...EMPTY_CARD_VALUES, ...initial }}
        submitLabel="Add card"
        submitting={submitting}
        errors={errors}
        onSubmit={handleSubmit}
      />
    </Modal>
  )
}
